var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c("v-tab", [_vm._v("\n        Metrics\n      ")]),
              _vm._v(" "),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "", "align-center": "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("h3", { staticClass: "headline mb-0" }, [
                                  _vm._v("Metrics"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs1: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        icon: "",
                                        color: "grey lighten-1",
                                        loading:
                                          _vm.loadingCollectors || _vm.loading,
                                      },
                                      on: { click: _vm.refresh },
                                    },
                                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs1: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs5: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "fal fa-search",
                                      placeholder: "Search",
                                      "single-line": "",
                                      "hide-details": "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function ($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.allCollectors,
                                      "item-text": "id",
                                      "item-value": "id",
                                      label: "Source Collector",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.selectedCollectorId,
                                      callback: function ($$v) {
                                        _vm.selectedCollectorId = $$v
                                      },
                                      expression: "selectedCollectorId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs1: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs5: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.metricSources,
                                      multiple: "",
                                      "small-chips": "",
                                      "deletable-chips": "",
                                      label: "Metrics Source",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.selectedMetricSources,
                                      callback: function ($$v) {
                                        _vm.selectedMetricSources = $$v
                                      },
                                      expression: "selectedMetricSources",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          items: _vm.metricsBySource(),
                          search: _vm.search,
                          loading: _vm.loading,
                          headers: _vm.headers,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }